import { render } from "./PricingHome.vue?vue&type=template&id=5dc05a7b&scoped=true"
import script from "./PricingHome.vue?vue&type=script&lang=js"
export * from "./PricingHome.vue?vue&type=script&lang=js"

import "./PricingHome.vue?vue&type=style&index=0&id=5dc05a7b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc05a7b"]])

export default __exports__